// extracted by mini-css-extract-plugin
module.exports = {"slickDeactive":"RGallery_slickDeactive__5SBaF"};